import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const TESTIMONIALS = [{
  initials: 'MG',
  name: 'Martín G.',
  details: '32 años, Buenos Aires',
  quote: 'Siempre quise usar IA para mi negocio pero no sabía por dónde empezar. Este curso me dio las herramientas exactas que necesitaba. En una semana ya estaba creando contenido profesional.'
}, {
  initials: 'CR',
  name: 'Camila R.',
  details: '28 años, Córdoba',
  quote: 'Soy creadora de contenido y la IA me cambió todo. Ahora genero imágenes y videos en minutos. El curso es súper práctico y fácil de seguir.'
}, {
  initials: 'FL',
  name: 'Federico L.',
  details: '41 años, Rosario',
  quote: 'Tengo un negocio de marketing y este curso me ahorró horas de trabajo. Las clases de voces con IA y creación de videos son increíbles.'
}, {
  initials: 'VS',
  name: 'Valentina S.',
  details: '35 años, Mendoza',
  quote: 'No tenía idea de que existían tantas herramientas de IA. Ahora las uso todos los días para mis proyectos freelance. 100% recomendado.'
}, {
  initials: 'LM',
  name: 'Lucas M.',
  details: '27 años, La Plata',
  quote: 'Empecé sin saber nada de inteligencia artificial y ahora estoy generando ingresos extra con lo que aprendí. El mejor curso que hice este año.'
}];
const STARS = Array.from({
  length: 5
});
export function TestimonialsSection() {
  return <section className="bg-[#0a0a0a] py-24 px-4 border-t-4 border-[#a855f7]" data-id="element-207">
      <div className="max-w-6xl mx-auto" data-id="element-208">
        <h2 className="text-4xl md:text-5xl font-black text-center text-white mb-16" data-id="element-209">
          Lo que dicen nuestros alumnos
        </h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.4
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-210">
          {TESTIMONIALS.map((t, i) => <div key={i} className="bg-[#111] border border-white/10 rounded-2xl p-8 relative" data-id="element-211">
              <div className="flex items-center gap-4 mb-6" data-id="element-212">
                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#a855f7] to-[#3b1466] flex items-center justify-center text-xl font-bold text-white border-2 border-[#FFD700]" data-id="element-213">
                  {t.initials}
                </div>
                <div data-id="element-214">
                  <h4 className="text-lg font-bold text-white" data-id="element-215">{t.name}</h4>
                  <p className="text-sm text-[#c4b5d4]" data-id="element-216">{t.details}</p>
                </div>
              </div>
              <div className="flex gap-1 mb-4" data-id="element-217">
                {STARS.map((_, idx) => <StarIcon key={idx} className="w-5 h-5 fill-[#FFD700] text-[#FFD700]" data-id="element-218" />)}
              </div>
              <p className="text-lg text-white/90 italic leading-relaxed" data-id="element-219">
                "{t.quote}"
              </p>
            </div>)}
        </motion.div>
      </div>
    </section>;
}